import { Expose } from "class-transformer";

import { PlanModel } from "./plan.model";

export enum OrganizationType {
  INDIVIDUAL = "INDIVIDUAL",
  PUBLIC = "PUBLIC"
}

export class Organization {
  @Expose()
  id!: string;

  @Expose()
  name!: string;

  @Expose()
  description?: string;

  @Expose()
  type!: OrganizationType;

  @Expose()
  isSuspended!: boolean;

  @Expose()
  apiEnabled!: boolean;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  plan?: PlanModel;

  @Expose()
  planId?: string;

  @Expose()
  planSubscribedAt?: string;

  @Expose()
  usage?: {
    totalTokensUsed: number;
    totalAiRequestsUsed: number;
    tokensUsed: number;
    aiRequestsUsed: number;
    documents: {
      totalPublic: number;
      totalPrivate: number;
      totalShared: number;
    };
  };

  @Expose()
  _count?: {
    users: number;
  };

  constructor(model: Partial<Organization>) {
    Object.assign(this, model);
  }
}
